// ag-grid/chart license moved to integration settings since 2024-12-23

const agGridLicenseKey = import.meta.env.DEV
  ? import.meta.env.VITE_AGGRID_LICENSE_KEY // load key from .env.local in dev mode
  : window.siteVars.agGridLicenseKey

export default agGridLicenseKey
